import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import FormField from '../../../forms/FormField';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { Col } from 'react-bootstrap';

import PromoCodeFormSection from './PromoCodeFormSection';

const required = value => value ? undefined : 'Required';

const getCardName = cardTypeId => {
  switch (cardTypeId) {
    case 1:
      return 'MASTERCARD';
    case 2:
      return 'VISA';
    case 3:
      return 'AMEX';
    case 8:
      return 'DISCOVER';
    default:
      return 'Unknown';
  }
};

const CheckoutBillingForm = props => {
  const {
    makeDefaultBillingValue,
    handleSubmit,
    lookups,
    AddressBook,
    CreditCards,
    loggedIn,
    change,
    submitting,
    sameAsShippingValue,
    cardIdValue,
    shipping,
    IsWillCall,
    submitFailed,
    invalid,
    saveCardValue,
    promoCodeValue,
    onPostPromoCode,
    onDelPromoCode: handlePromoCodeDelete,
    cartPromoCode,
    promoCodeResult,
    delPromoCodeResult
  } = props;

  const {
    states
  } = lookups || {};

  const { inProgress: promoCodeInProgress } = promoCodeResult || {};
  const { inProgress: delPromoCodeInProgress } = delPromoCodeResult || {};

  const stateOptions = (states || [])
    .filter(({ countryId }) => countryId === 37)
    .map(({ stateId, stateName }) => ({
      value: stateId,
      label: stateName
    }));

  const addressBookOptions = (AddressBook || []).map(address => {
    const { Label, Address1, City } = address || {};
    return {
      value: address,
      label: `${Label || ''} ${Address1 || ''} ${City || ''}`
    };
  });

  const creditCardOptions = (CreditCards || []).map(card => {
    const { CardId, LastFour, CardTypeId } = card || {};
    return {
      value: CardId,
      label: `${getCardName(CardTypeId)} **** **** **** ${LastFour || ''}`
    };
  });

  const handleAddressBookChange = address => {
    const {
      FirstName: name_first,
      LastName: name_last,
      Company: company,
      Address1: address1,
      Address2: address2,
      City: city,
      Zip: zip,
      Phone: phone,
      StateID: stateId
    } = address || {};

    change('name_first', name_first);
    change('name_last', name_last);
    change('company', company);
    change('address1', address1);
    change('address2', address2);
    change('city', city);
    change('zip', zip);
    change('phone', phone);
    change('stateId', stateId);
  };

  const copyShipping = () => {
    const {
      name_first,
      name_last,
      company,
      address1,
      address2,
      city,
      zip,
      phone,
      stateId
    } = shipping || {};

    // change('addressBookId', null);
    change('name_first', name_first);
    change('name_last', name_last);
    change('company', company);
    change('address1', address1);
    change('address2', address2);
    change('city', city);
    change('zip', zip);
    change('phone', phone);
    change('stateId', stateId);
  };

  const handlePromoCodeSubmit = () => onPostPromoCode(promoCodeValue)

  return (
    <form onSubmit={handleSubmit}>

      {!loggedIn &&
        <section className="form-bit">
          <div className="form-row">
            <div className="col-md-6">
              <Field
                name="email"
                type="email"
                label="Email"
                component={FormField.Input}
                placeholder="Email"
                validate={[required]}
              />
            </div>
          </div>
        </section>}

      <section className="form-bit">
        <h3 className="column-header">Billing Address</h3>
        <div className="form-row">

          {loggedIn &&
            <div className="col-md-12">
              <Field
                name="addressBookId"
                type="text"
                component={FormField.SelectReact}
                placeholder="Select from address book"
                options={addressBookOptions}
                onChange={handleAddressBookChange}
              />
              <div className="form-group form-group-gift-checkbox">
                <div
                  className="form-check inline"
                  onClick={() =>
                    change('makeDefaultBilling', !makeDefaultBillingValue)}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="makeDefaultBilling"
                    value="option1"
                    checked={makeDefaultBillingValue}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: '16px', paddingBottom: '10px' }}
                  >
                    Make default billing address
                  </label>
                </div>
              </div>
            </div>}

          {!IsWillCall &&
            <div className="col-md-12">
              <div className="form-group form-group-gift-checkbox">
                <div
                  className="form-check inline"
                  onClick={() => {
                    if (!sameAsShippingValue === true) {
                      copyShipping();
                    }
                    change('sameAsShipping', !sameAsShippingValue);
                  }}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="sameAsShipping"
                    value="option1"
                    checked={sameAsShippingValue}
                  />
                  <label
                    className="form-check-label"
                    style={{ fontSize: '16px', paddingBottom: '10px' }}
                  >
                    Same as Shipping Address
                  </label>
                </div>
              </div>
            </div>}

          <div className="col-md-6">
            <Field
              name="name_first"
              type="text"
              component={FormField.Input}
              placeholder="First Name"
              validate={[required]}
            />
          </div>
          <div className="col-md-6">
            <Field
              name="name_last"
              type="text"
              component={FormField.Input}
              placeholder="Last Name"
              validate={[required]}
            />
          </div>
        </div>
        <Field
          name="address1"
          type="text"
          component={FormField.Input}
          placeholder="Address"
          validate={[required]}
        />
        <Field
          name="address2"
          type="text"
          component={FormField.Input}
          placeholder="Address 2"
        />
        <div className="form-row">
          <div className="col-md-4">
            <Field
              name="city"
              type="text"
              component={FormField.Input}
              placeholder="City"
              validate={[required]}
            />
          </div>
          <div className="col-md-4">
            <Field
              name="stateId"
              type="text"
              component={FormField.SelectReact}
              placeholder="State"
              validate={[required]}
              options={stateOptions}
            />
          </div>
          <div className="col-md-4">
            <Field
              name="zip"
              type="text"
              component={FormField.Input}
              placeholder="Postal Code"
              validate={[required]}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="col-md-6">
            <Field
              name="phone"
              type="text"
              component={FormField.Input}
              placeholder="Phone Number"
              validate={[required]}
            />
          </div>
        </div>
      </section>

      <section className="form-bit">
        <h3 className="column-header">Payment</h3>
        {loggedIn &&
          <div className="form-row">
            <div className="col-md-12">
              <Field
                name="cardId"
                type="text"
                component={FormField.SelectReact}
                placeholder="Select payment method"
                options={[
                  {
                    value: 'new',
                    label: 'New Credit Card'
                  },
                  ...creditCardOptions
                ]}
              />
            </div>
          </div>}
        {(!loggedIn || cardIdValue === 'new') &&
          <div>
            <div className="form-row">
              <div className="col-md-6">
                <Field
                  name="cardNumber"
                  type="text"
                  component={FormField.Input}
                  placeholder="Card Number"
                  validate={[required]}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-4">
                <Field
                  name="expirationMonth"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Month"
                  validate={[required]}
                  options={[
                    { value: 1, label: 'January' },
                    { value: 2, label: 'February' },
                    { value: 3, label: 'March' },
                    { value: 4, label: 'April' },
                    { value: 5, label: 'May' },
                    { value: 6, label: 'June' },
                    { value: 7, label: 'July' },
                    { value: 8, label: 'August' },
                    { value: 9, label: 'September' },
                    { value: 10, label: 'October' },
                    { value: 11, label: 'November' },
                    { value: 12, label: 'December' }
                  ]}
                />
              </div>
              <div className="col-md-4">
                <Field
                  name="expirationYear"
                  type="text"
                  component={FormField.SelectReact}
                  placeholder="Year"
                  validate={[required]}
                  options={Array.from(Array(90), (_, i) => ({
                    value: new Date().getFullYear() + i,
                    label: new Date().getFullYear() + i
                  }))}
                />
              </div>
              <div className="col-md-4">
                <Field
                  name="cvv"
                  type="text"
                  component={FormField.Input}
                  placeholder="CVV"
                  validate={[required]}
                />
              </div>
            </div>
          </div>}
          {loggedIn && cardIdValue === 'new' && (
            <div
              className="form-check inline"
              onClick={() =>
                change('saveCard', !saveCardValue)}
            >
              <input
                className="form-check-input"
                type="radio"
                name="saveCard"
                value="option1"
                checked={saveCardValue}
              />
              <label
                className="form-check-label"
                style={{ fontSize: '16px', paddingBottom: '10px' }}
              >
                Save Card
              </label>
            </div>
          )}
      </section>

      <PromoCodeFormSection
        promoCodeValue={promoCodeValue}
        handlePromoCodeSubmit={handlePromoCodeSubmit}
        handlePromoCodeDelete={handlePromoCodeDelete}
        cartPromoCode={cartPromoCode}
        promoCodeResult={promoCodeResult}
        delPromoCodeResult={delPromoCodeResult}
      />

      <section className="form-bit">
        <div className="form-row justify-content-end">
          {invalid && submitFailed && (
            <Col sm={12}>
              <p style={{ color: '#dc3545', padding: '10px 0' }}>
                Form is invalid. Please fix errors and resubmit
              </p>
            </Col>
          )}
          <div className="col-md-4">
            <Link
              to="/shop/checkout/shipping"
              className={classNames(
                'btn btn-inverse btn-block',
                submitting || promoCodeInProgress || delPromoCodeInProgress ? 'disabled' : ''
              )}
            >
              Go Back
            </Link>
          </div>
          <div className="col-md-4">
            <button
              type="submit"
              id="tag-button-billing"
              className="btn btn-primary btn-block"
              disabled={submitting || promoCodeInProgress || delPromoCodeInProgress}
            >
              Continue
            </button>
          </div>
        </div>
      </section>

    </form>
  );
};

const formName = 'checkout-billing-form';

const form = reduxForm({
  form: formName
})(CheckoutBillingForm);

const selector = formValueSelector(formName);

const mapState = state => {
  const makeDefaultBillingValue = selector(state, 'makeDefaultBilling');
  const sameAsShippingValue = selector(state, 'sameAsShipping');
  const cardIdValue = selector(state, 'cardId');
  const saveCardValue = selector(state, 'saveCard');
  const promoCodeValue = selector(state, 'promoCode');
  return {
    makeDefaultBillingValue,
    sameAsShippingValue,
    cardIdValue,
    saveCardValue,
    promoCodeValue
  };
};

const mapDispatch = dispatch => bindActionCreators({}, dispatch);

export default connect(mapState, mapDispatch)(form);
